<div class="relative flex flex-col w-full h-full bg-card dark:bg-transparent">
  <!-- Header -->
  <div
    class="flex items-center justify-between px-6 py-4 border-b bg-default dark:bg-black dark:bg-opacity-5"
    *ngIf="title"
  >
    <div class="text-xl font-medium">{{ title }}</div>
    <button mat-icon-button [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Main Image Display -->
  <div class="flex-auto flex items-center justify-center p-8 overflow-hidden">
    <img [src]="currentImage" alt="Image" class="max-w-full max-h-full object-contain" />
  </div>

  <!-- Navigation Controls -->
  <div class="flex items-center justify-center px-6 py-4 border-t bg-default dark:bg-black dark:bg-opacity-5">
    <div class="flex items-center gap-4">
      <!-- Previous Button -->
      <button mat-icon-button [disabled]="!hasPrevious" (click)="previous()">
        <mat-icon>chevron_left</mat-icon>
      </button>

      <!-- Image Counter -->
      <div class="text-sm font-medium">{{ currentIndex + 1 }} / {{ images.length }}</div>

      <!-- Next Button -->
      <button mat-icon-button [disabled]="!hasNext" (click)="next()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>

  <!-- Thumbnail Strip -->
  <div class="flex items-center justify-center px-6 py-4 border-t bg-default dark:bg-black dark:bg-opacity-5">
    <div class="flex gap-2 overflow-x-auto max-w-full">
      <div
        *ngFor="let image of images; let i = index"
        class="flex-shrink-0 cursor-pointer border-2 rounded overflow-hidden"
        [class.border-primary]="i === currentIndex"
        [class.border-transparent]="i !== currentIndex"
        (click)="goToImage(i)"
      >
        <img [src]="image" alt="Thumbnail {{ i + 1 }}" class="w-16 h-16 object-cover" />
      </div>
    </div>
  </div>
</div>
